import { BRAND } from "@/config/brand";

/**
 * Text-based wordmark for the CRA3D brand. Reads BRAND.name so the public
 * name can be swapped without touching consumer components. The accent
 * suffix (BRAND.name_accent, e.g. "3D") is rendered in the warm-amber
 * accent color to give the wordmark a distinctive read without any
 * graphic asset. The trademark glyph is opt-in per usage per brand rules
 * (prominent brand statements only — hero, footer ownership, PDF cover,
 * policy headers).
 */
export function Wordmark({ size = "md", className = "", testid = "wordmark", showTrademark }) {
  const sizeCls = {
    sm: "text-lg tracking-[0.18em]",
    md: "text-2xl tracking-[0.22em]",
    lg: "text-4xl sm:text-5xl tracking-[0.26em]",
    xl: "text-4xl sm:text-6xl lg:text-7xl tracking-[0.18em] sm:tracking-[0.28em]",
  }[size];
  const accent = BRAND.name_accent || "";
  const prefix = accent && BRAND.name.endsWith(accent)
    ? BRAND.name.slice(0, BRAND.name.length - accent.length)
    : BRAND.name;
  const shouldShowTM = (showTrademark === undefined)
    ? (size === "xl" || size === "lg")
    : !!showTrademark;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-baseline font-heading font-medium text-fg-primary ${sizeCls} ${className}`}
    >
      <span>{prefix}</span>
      {accent && (
        <span data-testid={`${testid}-accent`} className="text-accent-warm">{accent}</span>
      )}
      {shouldShowTM && BRAND.trademark && (
        <span
          aria-hidden="true"
          data-testid={`${testid}-tm`}
          className="ml-0.5 text-[0.4em] font-normal align-super text-fg-secondary tracking-normal"
        >
          {BRAND.trademark}
        </span>
      )}
    </span>
  );
}

export default Wordmark;
